import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Card, CardBody, Badge, Button } from "reactstrap";
import { formatUserName, stageOf } from "../helpers";

const KanbanCard = ({ hit, steps, openForm, goToList, waiting, isProcessClosed, canEdit }) => {
  const st         = stageOf(hit._source.applicant.enrollment, steps);
  const noStage    = !st; // “Aceptados”
  const inFlight   = waiting.has(hit._id);
  const dragBlockInner  = inFlight || ["pending", "rejected"].includes(st?.aasm_state);

  const dragDisabled = isProcessClosed || dragBlockInner;

  const { attributes, listeners, setActivatorNodeRef, setNodeRef,
    transform, transition } =
    useSortable({ id: hit._id, disabled: dragDisabled });

  const style     = { transform: CSS.Translate.toString(transform), transition };
  const dragStyle = {
    cursor: dragDisabled && !canEdit ? "not-allowed" : "grab",
    opacity: dragDisabled ? 0.5 : 1
  };

  const postId = hit._source.postulation_id || hit._source.id;
  const user   = hit._source.applicant.user;
  const displayName = formatUserName(user);

  const badge = inFlight
    ? { label: "pending", color: "secondary" }
    : st
      ? { label: st.aasm_state, color: {
          pending:"secondary", editable:"info",
          approved:"success", rejected:"danger"
        }[st.aasm_state] }
      : { label: "aceptado", color: "secondary" };

  const dragTitle = isProcessClosed
    ? "Proceso cerrado: no se puede mover"
    : !canEdit
      ? "Solo lectura para jefatura"
      : dragBlockInner
        ? "No disponible para mover"
        : "Arrastrar para mover";

  return (
    <Card id={`board-card-${postId}`} innerRef={setNodeRef}
          style={style} className="mb-2 shadow-sm kanban-card" {...attributes}>
      <CardBody className="p-3 position-relative">
        <span
          ref={setActivatorNodeRef}
          {...(!dragDisabled ? listeners : {})}
          className="position-absolute top-0 end-0 p-2"
          style={dragStyle}
          title={dragTitle}
          aria-disabled={dragDisabled}
          tabIndex={-1}
        >
          <i className="fas fa-grip-vertical text-muted" />
        </span>

        <div className="fw-bold small mb-1">{displayName}</div>

        {!noStage && (
          <>
            <Badge color={badge.color} pill className="mt-2">{badge.label}</Badge>
            {!inFlight && canEdit && !isProcessClosed && (
              <Button color="link" size="sm" className="p-0 ms-2"
                      title="Gestionar etapa"
                      onClick={e => { e.stopPropagation(); openForm(hit); }}>
                <i className="fas fa-edit" />
              </Button>
            )}
          </>
        )}

        <Button color="link" size="sm" className="p-0 ms-1"
                title="Ver en lista"
                onClick={e => { e.stopPropagation(); goToList(postId); }}>
          <i className="fas fa-eye" />
        </Button>
      </CardBody>
    </Card>
  );
};

export default React.memo(KanbanCard);
